'use client';

import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

type MobileThreadsContextValue = {
  open: boolean;
  openThreads: () => void;
  setOpen: (open: boolean) => void;
};

const MobileThreadsContext = createContext<MobileThreadsContextValue | null>(null);

export function MobileThreadsProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openThreads = useCallback(() => setOpen(true), []);
  const value = useMemo(() => ({ open, openThreads, setOpen }), [open, openThreads]);

  return <MobileThreadsContext.Provider value={value}>{children}</MobileThreadsContext.Provider>;
}

export function useMobileThreads() {
  const context = useContext(MobileThreadsContext);
  if (!context) throw new Error('useMobileThreads must be used within MobileThreadsProvider');
  return context;
}
